import { Button } from "@buildpy/ui/button";
import { cn } from "@/lib/utils";
import { formatWon } from "@buildpy/core/lib/format";
import { calcSaleOf, isSaleOverridden } from "@buildpy/core/modules/quote/editor/reducer";
import type { VatMode } from "@buildpy/core/modules/money/vat";
import type { EditorItem } from "@buildpy/core/modules/quote/editor/types";

interface Props {
  item: EditorItem;
  vatMode: VatMode;
  onReset: () => void;
  // 좁은 표 칸 — 「직접 입력 · 되돌리기」 만 보이고 계산값은 title 로.
  compact?: boolean;
  className?: string;
}

// 판매가를 원가 × (1 + 기준 마진) 과 다르게 적은 줄의 안내 — 「판매가 직접 입력 · 계산값 X · 되돌리기」.
const SaleOverrideNote = ({ item, vatMode, onReset, compact = false, className }: Props) => {
  const calc = calcSaleOf(item, vatMode);
  if (calc === null || !isSaleOverridden(item, vatMode)) return null;
  const full = `판매가 직접 입력 · 계산값 ${formatWon(calc)}`;
  return (
    <span
      className={cn("flex flex-wrap items-center gap-x-1 text-xs text-warning", compact && "justify-end px-1.5 leading-tight", className)}
      data-sale-override=""
      title={compact ? full : undefined}>
      <span>{compact ? "직접 입력" : full}</span>
      <span aria-hidden>·</span>
      <Button
        aria-label={`계산값 ${formatWon(calc)}으로 되돌리기`}
        size="xs"
        type="button"
        variant="link"
        onClick={onReset}>
        되돌리기
      </Button>
    </span>
  );
};

export default SaleOverrideNote;
